import { BrandLogo } from "../components/BrandLogo/BrandLogo";
import instagramHtml from "../../../frontend/marketing/instagram-comments-guide.html?raw";
import instagramGuide from "../../../frontend/marketing/instagram-comments-guide.json";
import instagramAutoReplyToolsHtml from "../../../frontend/marketing/instagram-auto-reply-tools-guide.html?raw";
import instagramAutoReplyToolsGuide from "../../../frontend/marketing/instagram-auto-reply-tools-guide.json";
import facebookHtml from "../../../frontend/marketing/facebook-enquiries-guide.html?raw";
import facebookGuide from "../../../frontend/marketing/facebook-enquiries-guide.json";
import facebookAutoReplyToolsHtml from "../../../frontend/marketing/facebook-auto-reply-tools-guide.html?raw";
import facebookAutoReplyToolsGuide from "../../../frontend/marketing/facebook-auto-reply-tools-guide.json";
import whatsappHtml from "../../../frontend/marketing/whatsapp-leads-guide.html?raw";
import whatsappGuide from "../../../frontend/marketing/whatsapp-leads-guide.json";
import whatsappAutoReplyToolsHtml from "../../../frontend/marketing/whatsapp-auto-reply-tools-guide.html?raw";
import whatsappAutoReplyToolsGuide from "../../../frontend/marketing/whatsapp-auto-reply-tools-guide.json";
import { usePublicPageMetadata } from "./usePublicPageMetadata";
import "./MarketingHome.css";
import "./SolutionPage.css";
import "./InstagramCommentsGuide.css";

export const publicGuides = {
  instagram: { metadata: instagramGuide, articleHtml: instagramHtml, solutionPath: "/instagram-crm/", solutionLabel: "Instagram CRM" },
  instagramAutoReplyTools: { metadata: instagramAutoReplyToolsGuide, articleHtml: instagramAutoReplyToolsHtml, solutionPath: "/instagram-comment-auto-reply/", solutionLabel: "Automatic reply to Instagram comments" },
  facebook: { metadata: facebookGuide, articleHtml: facebookHtml, solutionPath: "/facebook-lead-crm/", solutionLabel: "Facebook CRM" },
  facebookAutoReplyTools: { metadata: facebookAutoReplyToolsGuide, articleHtml: facebookAutoReplyToolsHtml, solutionPath: "/facebook-lead-crm/", solutionLabel: "Facebook CRM" },
  whatsapp: { metadata: whatsappGuide, articleHtml: whatsappHtml, solutionPath: "/whatsapp-crm/", solutionLabel: "WhatsApp CRM" },
  whatsappAutoReplyTools: { metadata: whatsappAutoReplyToolsGuide, articleHtml: whatsappAutoReplyToolsHtml, solutionPath: "/whatsapp-crm/", solutionLabel: "WhatsApp CRM" },
} as const;

export type PublicGuideKind = keyof typeof publicGuides;

export function PublicGuidePage({ kind }: { kind: PublicGuideKind }) {
  const guide = publicGuides[kind];
  usePublicPageMetadata({ ...guide.metadata, ogType: "article" });

  return (
    <main className="pm-site ig-guide-site">
      <header className="pm-header">
        <nav className="pm-nav" aria-label="Public navigation">
          <a className="pm-brand" href="/" aria-label="LeadCat CRM homepage">
            <BrandLogo product="crm" variant="lockup" size="small" className="pm-brand-logo" />
          </a>
          <div className="pm-nav-actions">
            <a className="pm-nav-link" href={guide.solutionPath}>{guide.solutionLabel}</a>
            <a className="pm-nav-link" href="/react/login">Sign in</a>
          </div>
        </nav>
      </header>
      {/* Trusted, repository-authored HTML shared with the Python public renderer. */}
      <div dangerouslySetInnerHTML={{ __html: guide.articleHtml }} />
      <footer className="pm-footer">
        <div className="pm-footer-brand"><a href="/" aria-label="LeadCat CRM homepage"><BrandLogo product="crm" variant="lockup" size="small" className="pm-footer-logo" /></a><p>LeadCat CRM is a product from Staminal Technologies.</p></div>
        <nav aria-label="Legal links"><a href="/privacy.html">Privacy</a><a href="/terms.html">Terms</a></nav>
      </footer>
    </main>
  );
}
